//当前登录账户模块
export default {
    namespaced: true,
    state: {
        user: {}
    },
    getters: {
        //返回
        getUserInfo(state) {
            return state.user;
        }
    },
    mutations: {
        //该方法，用于对user对象复制
        setUser(state, val) {
            state.user = val;
        },
        //清空user
        clearUser() {
            state.user.value = null;
        }
    }
}